import { ref } from "vue";
import { defineComponent } from "vue";
import { useAuthStore } from "@/stores/auth.js";
import { useApiClient } from "@/utils/apiClient";
import { useI18n } from "vue-i18n";

export const useLocalization = function () {
  const api = useApiClient();
  const i18n = useI18n();
  const auth = useAuthStore();
  const locales = [
    { code: "lv", name: "Latviešu" },
    { code: "en", name: "English" },
//    { code: "ru", name: "Русский" },
  ];

  function localesList() {
    return locales;
  }

  function localeGet() {
    return i18n.locale.value;
  }

  function localeSet(localeCode) {
    i18n.locale.value = localeCode;
  }

  function localeChange(localeCode) {
    localeSet(localeCode);
    auth.preferredLocaleSet(localeCode);
    location.reload();
  }

  function t(key, parameters = {}) {
    return i18n.t(key, parameters);
  }

  return {
    localesList,
    localeGet,
    localeSet,
    localeChange,
    t,
  };
};
